import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import apiErrors from './apiErrors';
import builder from './builder';
import campuses from './campuses';
import countries from './countries';
import courses from './courses';
import currencies from './currencies';
import employers from './employers';
import errors from './errors';
import ineligibleLoanError from './ineligibleLoanError';
import loading from './loading';
import navigation from './navigation';
import provisionalOffer from './provisionalOffer';
import recoverableError from './recoverableError';
import schools from './schools';
import signedOutError from './signedOutError';
import states from './states';
import universities from './universities';
import unrecoverableError from './unrecoverableError';
import updateProvisionalOffer from './updateProvisionalOffer';
import user from './user';
import zendesk from './zendesk';

function rootReducer(history) {
  return combineReducers({
    router: connectRouter(history),
    countries,
    provisionalOffer,
    updateProvisionalOffer,
    states,
    courses,
    schools,
    universities,
    apiErrors,
    builder,
    campuses,
    currencies,
    navigation,
    errors,
    user,
    zendesk,
    employers,
    signedOutError,
    unrecoverableError,
    recoverableError,
    ineligibleLoanError,
    loading,
  });
}

export default rootReducer;
